import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { ApiResponse } from '@/api/handlers/responses';
import { clearAuthSession, getRefreshToken } from '@/utils/authSession';

/**
 * Logout mutation. Best-effort revokes the refresh token server-side (the
 * endpoint is idempotent and 204s), then always clears the local session — the
 * client is logged out regardless of whether the network call lands. When
 * there's no refresh token to revoke we skip the round-trip and just clear.
 */
export const useLogoutMutation = () => {
    const { apiClient } = useApi();

    return useMutation<ApiResponse<void> | null, Error, void>({
        mutationFn: () => {
            const refreshToken = getRefreshToken();
            if (!refreshToken) {
                return Promise.resolve(null);
            }
            return apiClient.auth.logout({ refreshToken });
        },
        onSettled: () => {
            clearAuthSession();
        },
    });
};
